import { Fragment, useEffect, useState } from 'react';
import LoadMoreButton from '@rio-cloud/rio-uikit/LoadMoreButton';

export type PagingButtonType = {
    onLoad: number;
    hasMore: number;
    onLoadMore: (newAmount: number) => void;
}

const PagingButton = (props: PagingButtonType) => {
    let { onLoad, hasMore, onLoadMore } = props;
    const [localState, setLocalState] = useState(onLoad);
    const ITEMS_PER_LOAD = 50;

    useEffect(() => {
        setLocalState(onLoad);
    }, [onLoad]);

    const triggerLoad = () => {
        const newAmount = localState + ITEMS_PER_LOAD;
        setLocalState(newAmount);
        onLoadMore(newAmount);
    };

    return (
        <Fragment>
            <LoadMoreButton
                loaded={localState}
                total={hasMore}
                onLoadMore={triggerLoad}
                loadMoreMessage='Carregar'
                noMoreMessage='Fim da lista'
            />
        </Fragment>
    );
};

export default PagingButton;